import { FooterDef } from 'ui/components';

export const FooterDefFeature: React.FC<Umbraco.FooterDef> = ({ content }) => {
	return <FooterDef {...content?.properties} />;
};
